import LocalizedStrings from 'react-localization';
import { withCommon } from '../../services/common.translations';

const homeStrings = new LocalizedStrings({
  en: {
    search: 'Search for documents',
    links: {
      consultancy: {
        title: 'Consultancy'
      },
      training: {
        title: 'Training'
      },
      myDocuments: {
        title: 'My Documents',
        subtitle: 'Manage uploaded documents'
      },
      askAdvisor: {
        title: 'Ask an advisor',
        subtitle: 'Need to contact your advisor?'
      },
      other: {
        title: 'Other services',
        subtitle: 'Additional links to services'
      }
    },
    recentlyUpdated: 'Recently updated',
    newsletters: 'Newsletters',
    categories: {
      title: 'Categories',
      showAll: 'Show all'
    }
  }
});

export default withCommon<typeof homeStrings>(homeStrings);
